import type { ReactNode } from "react";
import { Modal } from "@/components/ui/Modal";
import { cn } from "@/lib/utils";

// Диалог подтверждения вместо window.confirm. Сам по себе — контролируемый
// компонент; промис-обёртка — useConfirm() (hooks/useConfirm.tsx).

export type ConfirmOptions = {
  title?: ReactNode;
  text?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Красная кнопка — для удаления и прочего необратимого. */
  danger?: boolean;
};

export function ConfirmDialog({
  open,
  title = "Подтвердите действие",
  text,
  confirmLabel = "Да",
  cancelLabel = "Отмена",
  danger,
  onConfirm,
  onCancel,
}: ConfirmOptions & {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      size="sm"
      footer={
        <>
          <button type="button" className="btn" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            type="button"
            autoFocus
            className={cn(danger ? "btn-danger" : "btn-primary")}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </>
      }
    >
      {text && (
        <div className="text-sm text-ink-600 dark:text-ink-300">{text}</div>
      )}
    </Modal>
  );
}

export default ConfirmDialog;
